<template>
  <Cart @submit="submit">
    <template #item="scope">
      <SportItem :data="scope" />
    </template>
  </Cart>
</template>
<script setup>
import { api } from '@/plugins/axios.js'
import { useCartStore } from '@/stores/cart.js'
import { useRouter } from 'vue-router'
import Cart from './Cart.vue'
import SportItem from './Items/SportItem.vue'
import { useAuthStore } from '@/stores/auth'
import { useDialog } from '@/composables/useDialog'
import { useQuasar } from 'quasar'
import { useConfigStore } from '@/stores/config.js'

const router = useRouter()
const cartStore = useCartStore()
const authStore = useAuthStore()
const configStore = useConfigStore()
const $q = useQuasar()
const { open } = useDialog()

async function submit () {
  open({ title: '배팅을 진행 하시겠습니까?' }).onOk(async () => {
    cartStore.submitting = true

    const bet_items = cartStore.items.map(item => ({
      game_id: item.game.id,
      market_id: item.market.id,
      argument: item.participant.argument,
      odds_name: item.odds.n,
    }))

    await api.post('pregame-bets', {
      bet_items,
      amount: cartStore.amount,
    }).then(() => {
      router.push({ name: 'bets', params: { category: 'pregame' } })
    }).finally(() => {
      cartStore.submitting = false
    })
    await authStore.fetch()
    if ($q.screen.lt.md){
      configStore.rightDrawerOpen = false
    }
  })

}
</script>
